module.exports = __webpack_public_path__ + "static/media/tip_text_dog_tick_fr.50ab4f97.svg";